var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDataFile = function SvgDataFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#CDC2E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 11.513v2.754c0 .373 0 .56.073.703a.667.667 0 0 0 .291.29c.143.074.33.074.703.074h2.754m.18 1.325v4.808c0 1.12 0 1.68-.219 2.108a2 2 0 0 1-.874.874c-.427.218-.988.218-2.108.218h-4.266c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874c-.218-.428-.218-.988-.218-2.108v-6.933c0-1.12 0-1.68.218-2.109a2 2 0 0 1 .874-.873c.428-.218.988-.218 2.108-.218h2.14c.49 0 .735 0 .965.055.204.049.399.13.578.24.202.123.375.296.72.642l2.126 2.125c.346.346.519.52.643.72a2 2 0 0 1 .24.579c.054.23.054.475.054.964Z",
    stroke: "#6F469A",
    strokeWidth: 1.333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#E3DEF2",
    strokeWidth: 4
  })));
};
export default SvgDataFile;